import React from 'react'
import {
  ReturnButton, WarningIcon, WarningTitle, WarningDescription,
} from './WarningBody.style'
import * as S from './WarningBody.style'
import { Invoice } from 'src/features/receivement/ReceivementTypes'

interface WarningBodyProps {
    warningTitle: string
    warningDescription: string | JSX.Element
    returnButtonAction?: () => void
    returnButtonLabel?: string
    invoiceList?: Invoice[]
    onClickResend?: (invoice) => string
}

export const WarningBody = ({
  warningTitle, warningDescription, invoiceList, returnButtonAction, returnButtonLabel = 'Voltar', onClickResend,
}: WarningBodyProps) => (
  <>
    <WarningIcon />
    <WarningTitle>{warningTitle}</WarningTitle>

    <WarningDescription>{warningDescription}</WarningDescription>
    <S.Container>
      <ul>
        {invoiceList?.map((invoice) => (
          <S.ContainerResend>
            <li><strong>Nr. </strong>{invoice.invoiceNumber}</li> - <strong>Chave:</strong> <li>{invoice.invoiceAccessKey }</li>
            <S.ButtonResend
              onClick={() => invoice && onClickResend && onClickResend(invoice.invoiceAccessKey)}
              title='Reenviar'
              variant='contained'
              size='medium'
              type='button'
              data-testid='resend-button'
            />
          </S.ContainerResend>
        ))}
      </ul>
    </S.Container>
    {returnButtonAction && (
      <ReturnButton variant='contained' size='large' type='button' onClick={returnButtonAction} data-testid='return-button'>{returnButtonLabel}</ReturnButton>
    )}
  </>
)
